import { render, staticRenderFns } from "./TreatmentDirectoryModals.vue?vue&type=template&id=4914cdd5"
import script from "./TreatmentDirectoryModals.vue?vue&type=script&lang=js"
export * from "./TreatmentDirectoryModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports